import { useEffect } from "react";
import { DEFAULT_META, SITE_URL } from "./data/pageMeta";

const INDEX = "index, follow, max-image-preview:large";

// Sets or creates a <meta> tag, e.g. setMeta("property", "og:title", "...")
function setMeta(attribute, key, content) {
  let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

// Points the page's title, description, canonical URL and link-preview tags at one URL.
// Called with nothing, it goes back to the home page's.
export function applyPageMeta({ title, description, path, noindex = false } = DEFAULT_META) {
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;
  document.title = title;
  setMeta("name", "description", description);
  setMeta("name", "robots", noindex ? "noindex, follow" : INDEX);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:url", url);
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  canonical.href = url;
}

// For a whole page: apply its meta while it is mounted, then hand back to the home page's
export default function usePageMeta(meta) {
  const { title, description, path, noindex } = meta;
  useEffect(() => {
    applyPageMeta({ title, description, path, noindex });
    return () => applyPageMeta();
  }, [title, description, path, noindex]);
}
